import utils from 'utils/utils';
import locale from 'player/model/locale';
import PluginModel from './model';

const SVP_FLAG_NATIVE_LINK = 'svp-flag-native-link';
const SVP_NATIVE_LINK_OVERLAY = 'svp-native-link-overlay';
const SVP_NATIVE_LINK_BUTTON = 'svp-native-link-button';
const SVP_LOGIN_OVERLAY = 'svp-login-overlay';

/**
 * Allowing using native link for playing podcasts on hermes apps
 *
 * @param options
 * @constructor
 */
class PodcastNativeLinkPlugin extends PluginModel {
    constructor(options) {
        super(options);
        this.link = null;
    }

    // eslint-disable-next-line
    getName() {
        return 'PodcastNativeLinkPlugin';
    }

    setup() {
        const asset = this.player.getAsset();

        if (utils.device.isHermesApp()) {
            if (utils.device.isIOS()) {
                this.link = `audio:${asset.getVendor()}:${asset.get('id')}`;
            } else if (utils.device.isAndroid()) {
                // TODO: Android support
            }
        }

        this.listenToOnce(this.player, 'viewable', this.render, this);
    }

    render() {
        if (!this.link) {
            return;
        }

        const translations = locale.getTranslations();
        const container = this.player.getContainer();

        // do not show when there is login overlay
        const loginOverlay = container.querySelector(`.${SVP_LOGIN_OVERLAY}`);
        if (loginOverlay) {
            return;
        }

        this.el = utils.createNode(`
            <a class="${SVP_NATIVE_LINK_OVERLAY}" href="${this.link}">
                <span class="${SVP_NATIVE_LINK_BUTTON}">${translations.player.listen}</span>
            </a>
        `);

        utils.addClass(container, SVP_FLAG_NATIVE_LINK);
        container.appendChild(this.el);
    }

    destroy() {
        if (this.el) {
            const container = this.player.getContainer();

            utils.removeClass(container, SVP_FLAG_NATIVE_LINK);

            const overlay = container.querySelector(`.${SVP_NATIVE_LINK_OVERLAY}`);
            if (overlay) {
                overlay.parentNode.removeChild(overlay);
            }
        }
    }
}

export default PodcastNativeLinkPlugin;
